interface PurchaseButtonsProps {
  onAmazonClick: () => void
  onRakutenClick: () => void
  isAmazonSaleActive: boolean
}

export default function PurchaseButtons({ onAmazonClick, onRakutenClick, isAmazonSaleActive }: PurchaseButtonsProps) {
  return (
    <section className='relative sticky bottom-0 w-full'>
      <div className='shadow-line' />
      <div className='p-2 text-center bg-white'>
        <div className='flex gap-2'>
          <a
            href='https://www.amazon.co.jp/dp/B0G117GHSW'
            target='_blank'
            rel='noreferrer noopener'
            className='rounded-lg tracking-tight relative border !border-mi-bg-primary bg-mi-bg-primary text-white p-2 w-full text-base font-semibold text-center block'
            onClick={onAmazonClick}
          >
            Amazonで購入
            {isAmazonSaleActive && (
              <span className='block text-xs font-light tracking-[-0.08px]'>今だけ10%OFF</span>
            )}
          </a>
          <a
            href='https://item.rakuten.co.jp/mixiofficial/mdp01-j/'
            target='_blank'
            rel='noreferrer noopener'
            className='rounded-lg tracking-tight relative border !border-mi-bg-primary bg-white text-mi-bg-primary p-2 w-full text-base font-semibold text-center flex items-center justify-center'
            onClick={onRakutenClick}
          >
            楽天市場で購入
          </a>
        </div>
      </div>
    </section>
  )
}
